<template>
  <footer v-if="nameRouter !== 'Landing'">
    <div
      class="pt-5"
      :class="contentdata.isDark ? 'bg-dark text-white' : 'bg-white text-dark'"
    >
      <div class="container text-center">
        <div class="row justify-content-center" style="opacity: 0.9">
          <div class="col-12 col-sm-auto">
            <a
              href="https://www.joinnus.com/termsandconditions"
              class="d-block py-2 py-md-3"
              :class="contentdata.isDark ? 'text-white' : 'text-dark'"
              target="_blank"
              rel="noopener noreferrer"
            >
              Condiciones legales
            </a>
          </div>
          <div class="col-12 col-sm-auto">
            <a
              href="https://www.joinnus.com/privacypolicies"
              class="d-block py-2 py-md-3"
              :class="contentdata.isDark ? 'text-white' : 'text-dark'"
              target="_blank"
              rel="noopener noreferrer"
            >
              Políticas de privacidad
            </a>
          </div>
          <div class="col-12 col-sm-auto">
            <a
              href="https://www.joinnus.com/cookiespolicy"
              class="d-block py-2 py-md-3"
              :class="contentdata.isDark ? 'text-white' : 'text-dark'"
              target="_blank"
              rel="noopener noreferrer"
            >
              Política de cookies
            </a>
          </div>
          <div class="col-12 col-sm-auto">
            <a
              href="https://reclamos.joinnus.com"
              class="d-block py-2 py-md-3"
              :class="contentdata.isDark ? 'text-white' : 'text-dark'"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                height="20"
                width="50"
                src="https://cdn.joinnus.com/files_cache/libro-reclamaciones.svg"
                alt="lr"
              />
              Libro de reclamaciones
            </a>
          </div>
        </div>
        <div class="row justify-content-between align-items-center mt-5 m-md-0">
          <div class="col col-sm-auto py-2">
            <a
              href="https://www.joinnus.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                class="d-inline-block align-top"
                :src="`https://cdn.joinnus.com/files/2022/autocinelimapark/joinnus-com-logo-${
                  contentdata.isDark ? 'white' : 'black'
                }.png`"
                height="40"
                alt="Joinnus"
            /></a>
          </div>
          <div
            class="col-md text-center py-2 passion-one"
            :style="{ opacity: contentdata.isDark ? 0.5 : 0.9 }"
          >
            Copyright © Joinnus 2022 - Todos los derechos reservados v1.41
          </div>
          <div class="col-sm-auto py-2">
            <a
              href="https://www.facebook.com/Joinnus/"
              target="_blank"
              class="btn btn-link btn-sm ml-0"
              rel="noopener noreferrer"
            >
              <img
                :src="`https://cdn.joinnus.com/files/2022/autocinelimapark/facebook-${
                  contentdata.isDark ? 'white' : 'black'
                }.png`"
                alt="Facebook"
                width="35"
              />
            </a>
            <a
              href="https://twitter.com/joinnus"
              target="_blank"
              class="btn btn-link btn-sm ml-0"
              rel="noopener noreferrer"
            >
              <img
                :src="`https://cdn.joinnus.com/files/2022/autocinelimapark/twitter-${
                  contentdata.isDark ? 'white' : 'black'
                }.png`"
                alt="Twitter"
                width="35"
              />
            </a>
            <a
              href="https://www.instagram.com/joinnus/"
              target="_blank"
              class="btn btn-link btn-sm ml-0"
              rel="noopener noreferrer"
            >
              <img
                :src="`https://cdn.joinnus.com/files/2022/autocinelimapark/instagram-${
                  contentdata.isDark ? 'white' : 'black'
                }.png`"
                alt="Instagram"
                width="35"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="isShowCookie">
      <div class="cookie-consent text-dark">
        <div class="row align-items-center justify-content-center">
          <div class="col-md-10">
            Utilizamos cookies propias y de terceros para mejorar tu experiencia
            en nuestro sitio web y para mostrarte publicidad personalizada.
            Algunas cookies son esenciales para la prestación del servicio y sin
            ellas el sitio no funcionará como se espera. Para más información,
            acceder a nuestra
            <a
              :href="policePrivacy"
              target="_blank"
              rel="noopener noreferrer"
              class="text-dark font-weight-bold"
            >
              <span>política de privacidad</span>
            </a>
            y a nuestra
            <a
              :href="policeCookies"
              target="_blank"
              rel="noopener noreferrer"
              class="text-dark font-weight-bold"
            >
              <span>política de cookies.</span>
            </a>
            Puedes aceptar todas las cookies pulsando el botón “Aceptar”, o
            configurarlas siguiendo las instrucciones indicadas en
            <a
              :href="policeCookies"
              target="_blank"
              rel="noopener noreferrer"
              class="text-dark font-weight-bold"
            >
              <span>nuestra política de cookies.</span>
            </a>
          </div>
          <div class="col-md-2 text-center v-center">
            <button
              type="button"
              class="btn btn-dark btn-block rounded-pill"
              @click="saveCookies"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </footer>
</template>
<script>

export default {
  data() {
    return {
      contentdata: {
        isDark: false,
      },
      isShowCookie: false,
      policePrivacy:
        'https://www.joinnus.com/privacypolicies',
      policeCookies:
        'https://www.joinnus.com/cookiespolicy',
    };
  },

  mounted() {
    this.getCookies();
  },

  computed: {
    termsAndConditions() {
      if (
        this.hostname === 'preprodfpf.joinnus'
        || this.hostname === 'fpf.joinnus.com'
      ) {
        return 'https://cdn.joinnus.com/files/2022/fpf/paraguay/terminos-condiciones-fpf-peru-paraguay.pdf';
      }
      return 'https://www.joinnus.com/termsandconditions';
    },
    hostname() {
      return window.location.hostname;
    },
    nameRouter() {
      return this.$route.name;
    },
  },

  methods: {
    getCookies() {
      const showCookie = localStorage.getItem('acceptCookie');
      if (showCookie === null) {
        this.isShowCookie = true;
      } else {
        this.isShowCookie = false;
      }
    },

    saveCookies() {
      localStorage.setItem('acceptCookie', true);
      this.isShowCookie = false;
    },
  },
};
</script>
<style lang="scss">
@media (max-width: 767px) {
  .navbar {
    padding: 0.2rem 1rem;
  }
}
.cookie-consent {
  font-size: 14px;
  margin: 16px 24px;
  background-color: #f1f6f5;
  border-radius: 0.5rem;
  box-shadow: 4px 20px 88px -6px rgba(60, 74, 72, 0.56);
  position: fixed;
  bottom: 0px;
  padding: 12px 20px;
  z-index: 200;
}
</style>
